import { motion, useReducedMotion } from 'framer-motion'
import { Container } from '@/components/ui/Container'
import { Section } from '@/components/ui/Section'
import { site } from '@/content/site'
import { smoothEase } from '@/lib/motion'

export function HomeBrandStatement() {
  const reduced = useReducedMotion()
  return (
    <Section className="bg-sage-wash/50">
      <Container>
        <motion.p
          className="mx-auto max-w-2xl text-center font-display text-xl font-medium leading-snug tracking-tight text-ink md:text-2xl"
          initial={reduced ? false : { opacity: 0, y: 10 }}
          whileInView={reduced ? undefined : { opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-60px' }}
          transition={{ duration: reduced ? 0 : 0.55, ease: smoothEase }}
        >
          {site.brandStatement}
        </motion.p>
      </Container>
    </Section>
  )
}
